/* istanbul ignore file */
import combineReducers from '../util/combineReducers/combineReducer';
import widgetSetup from './widgetSetup';
import pageRouting from './pageRouting';
import formControl from './formControl';

export default combineReducers(widgetSetup, pageRouting, formControl);
